import React from 'react'
import styled from 'styled-components'
import GaugeChart from 'react-gauge-chart'

interface GaugeProps {
  id?: string; // Unique ID for the gauge chart
  nrOfLevels?: number; // Number of segments in the gauge
  percent?: number; // Percentage value to display
  colors?: string[]; // Colors for the gauge
  arcWidth?: number; // Width of the gauge arc
  arcPadding?: number; // Padding between gauge segments
  textColor?: string; // Text color
  needleColor?: string; // Needle color
  formatTextValue?: (value: string) => string; // Custom text formatter
  cornerRadius?: number; // Radius for the corners of the arc
  containerStyle?: React.CSSProperties;
  label?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  > p {
    font-weight: 700;
    text-align: center;
    font-size: 14px;
  }
`;

const Gauge: React.FC<GaugeProps> = ({
  nrOfLevels = 4,
  arcWidth = 0.3,
  textColor = "#000000",
  percent = 0.37,
  containerStyle,
  label
}) => {
  return (
    <Container style={containerStyle}>
      <GaugeChart
        nrOfLevels={nrOfLevels}
        arcWidth={arcWidth}
        textColor={textColor}
        percent={percent}
      />
      <p>{label}</p>
    </Container>
  )
}

export default Gauge